/* eslint-disable */
import React, { useEffect, useMemo, useReducer, useState } from "react";
import { NotificationManager } from "react-notifications";
import api from "api";
import {
  editRegulationsRequestsType,
  editRegulationsRequestsStatus,
} from "dictionary/domains/EditRegulationsRequests";
import { Accordion, Form, Modal, Tab, Tabs } from "react-bootstrap";
import CustomToggle from "components/CustomToggle";
import Caret from "components/svgs/Caret";
import { useMap } from "context/mapContext";
import { useEsriUrls } from "context/esriUrlsContext";
import getVillages from "utils/selfUtils/getVillages";
import getHods from "utils/selfUtils/getHods";
import getSectors from "utils/selfUtils/getSectors";
import { useLoading, handleLoading } from "context/LoadingContext";
import { useLookups } from "context/lookupsContext";
import { useAuth } from "context/auth";
import { useForm, useWatch, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { dialogReducer, dialogInitState } from "reducers/dialog";
import getParcelsBasedCriteria, {
  fixParcelDataPadding,
} from "utils/selfUtils/getParcelsBasedCriteria";
import getEsriData from "context/contextFunctions/getEsriData";
import createFilterQuery from "utils/createFilterQuery";
import cleanObject from "utils/cleanObject";
import createSketch from "utils/createSketch";
import handleZoom from "utils/handleZoom";
import performActionOnFeature from "utils/performActionOnFeature";
import handleRangedItems from "utils/handleRangedItems";
import { ArrowLeft, Printer, Trash, ZoomIn } from "react-feather";
import useRoles from "customHooks/useRoles";
import useGetAllZones from "customHooks/useGetAllZones";
import addNewLog from "utils/addNewLog";
import EditParcelZoneCard from "components/EditParcelZoneCard.js";
import Dialog from "components/Dialog/Dialog";
import handleGetDataFromInput from "utils/handleGetDataFromInput";
import ParcelCard from "components/ParcelCard";
import PrintParcels from "components/PrintParcels";
import ParcelLaws from "./components/ParcelLaws";
import FilesModal from "./components/FilesModal";
import { generateTextFromJson } from "utils/generateTextFromJson";
import { Lock, Unlock } from "react-feather";
import { LockTypeEnum } from "dictionary/LockType/LockType";
import { ConvertObjectResultSaerch } from "./Service/CreateMappingData";
import handleZoomCustomShowResult from "utils/handelZoomCustom";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";
import Graphic from "@arcgis/core/Graphic";

export async function getHodAndVillNames({
  villCode,
  hodCode,
  token,
  villLayerId,
  hodLayerId,
  villQuery,
  hodQuery,
}) {
  const getVillPromise = getVillages({
    layerId: villLayerId,
    token,
    query: villQuery || `VILL_CODE = ${villCode}`,
  });

  const getHodPromise = getHods({
    layerId: hodLayerId,
    token,
    query: hodQuery || `HOD_CODE = ${hodCode} AND VILL_CODE = ${villCode}`,
  });
  try {
    const [vills, hods] = await Promise.all([getVillPromise, getHodPromise]);
    const villName = vills[0]?.VILL_ANAME;
    const hodName = hods[0]?.HOD_ANAME;
    return { villName, hodName, vills, hods };
  } catch (error) {
    ErrorHandelFunctionApp(error)
  }
  return {};
}

function ParcelsSearch() {
  const [badServerError, setBadServerError] = useState(false);
  const navigate = useNavigate();
  const [auth] = useAuth();
  const { permissions, roles } = useRoles();
  const [, setParcelsFeatureLayer] = useState(null);
  const [selectedAccordion, setSelectedAccordion] = useState("0");
  const [laws, setLaws] = useState(null);
  const [zones, setZones] = useState(null);
  const { zones: allZones } = useGetAllZones();
  const [searchedParcels, setSearchedParcels] = useState(null);
  const [map, dispatchMap] = useMap();
  const [lookups] = useLookups();
  const { zonesLookup } = lookups;
  const [selectedModalZone, setSelectedModalZone] = useState(null);
  const [landshaveRegulation,setLandshaveRegulation]=useState(false);
  const [SelectItem,setSelectItem]=useState("officialWork")
  
  
  useEffect(() => {
    if (zonesLookup) setSelectedModalZone(zonesLookup[0]);
  }, [zonesLookup]);

  const selectedModalZoneValue = useMemo(
    () =>
      selectedModalZone?.value
        ? zones?.find((item) => item.ZONE_ID === selectedModalZone?.value) || {}
        : {},
    [selectedModalZone, zones]
  );
  const {
    villages,
    hods,
    sectors,
    parcels,
    praParcelsFields,
    view,
    graphicsLayer,
    graphicsLayerSelectedParcels,
    sketchVM,
    sketchGraphicsLayer,
  } = map;
  const [esriUrls] = useEsriUrls();
  const [, loadingDispatch] = useLoading();
  const {
    register,
    control,
    trigger,
    getValues,
    formState: { errors },
    setValue,
  } = useForm();
  const watch = useWatch({ control });
  const editParcelZoneMethods = useForm();
  const {
    register: editParcelZoneRegister,
    handleSubmit: editParcelZoneHandleSubmit,
    formState: { errors: editParcelZoneError },
  } = editParcelZoneMethods;

  useEffect(() => {
    (async () => {
      if (
        !villages &&
        esriUrls.DLSParcelsLayer !== undefined &&
        auth.esriToken
      ) {
        handleLoading(loadingDispatch, true);
        try {
          const villagesRes = await getVillages({
            layerId: esriUrls.villagesLookup,
            dispatch: dispatchMap,
            villages,
            token: auth.esriToken,
          });
          await getHods({
            layerId: esriUrls.hodesLookUp,
            dispatch: dispatchMap,
            hods,
            token: auth.esriToken,
            villages: villagesRes.map((item) => item.VILL_CODE),
          });
          getSectors({
            layerId: esriUrls.sectorsLookup,
            dispatch: dispatchMap,
            sectors,
            token: auth.esriToken,
          });
          getParcelsBasedCriteria({
            layerId: esriUrls.DLSParcelsLayer,
            dispatch: dispatchMap,
            token: auth.esriToken,
            query: `VILL_CODE = ''`,
          });
        } catch (error) {
          ErrorHandelFunctionApp(error)
        }
        handleLoading(loadingDispatch, false);
      }
    })();
  }, [esriUrls.DLSParcelsLayer, auth.esriToken]);

  useEffect(() => {
    (async () => {
      if (view && esriUrls.Parcels_Intersect) {
        const {
          serverFeatureLayerQuery: parcelsFeatureLayerToSave,
          fields: parcelsIntersectFields,
        } = await getEsriData({
          token: auth.esriToken,
          layerId: esriUrls.Parcels_Intersect,
          layer: process.env.REACT_APP_PetraLayers_Table,
          featureOrMap: "MapServer",
          query: "1=1",
          view,
        });
        setParcelsFeatureLayer(parcelsFeatureLayerToSave);
        dispatchMap({
          type: "INIT",
          payload: {
            parcelsIntersectFields,
          },
        });
      }
    })();
  }, [view, esriUrls.Parcels_Intersect]);

  // handleFiles

  const [filesDialogState, filesDispatchDialog] = useReducer(
    dialogReducer,
    dialogInitState
  );
  const toggleFilesDialog = () => {
    filesDispatchDialog({ type: "TOGGLE" });
  };
  const [files, setFiles] = useState([]);

  // ----

  async function handleChangeSector(SECT_CODE) {
    handleLoading(loadingDispatch, true);
    try {
      const { parcelError: parcelErrorTemp } = await getParcelsBasedCriteria({
        data: {
          VILL_CODE: watch.VILL_CODE,
          HOD_CODE: watch.HOD_CODE,
          SECT_CODE,
        },
        layerId: esriUrls.DLSParcelsLayer,
        dispatch: dispatchMap,
        token: auth.esriToken,
      });
      if (parcelErrorTemp) {
        NotificationManager.warning(
          "معلومات دائرة الأراضي غير متوفرة حاليا الرجاء إعادة تحميل الصفحة"
        );
        setBadServerError(
          "معلومات دائرة الأراضي غير متوفرة حاليا الرجاء إعادة تحميل الصفحة"
        );
      }
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    handleLoading(loadingDispatch, false);
  }

  // drawings
  const [drawingGeometry, setDrawingGeometry] = useState(null);
  const clearDrawings = () => {
    sketchGraphicsLayer.removeAll();
    setDrawingGeometry(null);
  };

  const onSubmit = async () => {
    try{
    handleLoading(loadingDispatch, true);

    const noError = await trigger();
      if (!noError) return;
      const data = getValues();
      
    
      if (`${data.VILL_CODE}`) fixParcelDataPadding(data);
      data.SECTOR_CODE = data.SECT_CODE;
      delete data.SECT_CODE;
      const isEmpty = !Object.values(data).some((property) => property);
      if (isEmpty && !drawingGeometry) return;
        const fixedDotsData = Object.fromEntries(
          Object.entries(data).map((item) => [item[0].replace("%", "."), item[1]])
        );
        const cleanedData = cleanObject(fixedDotsData);
        const dataWithRangeHandled = handleRangedItems(cleanedData);
      
      function HandelCreateDlsKey(dataWithRangeHandled){
        if(dataWithRangeHandled?.DLS_KEY){
          return dataWithRangeHandled?.DLS_KEY;
        }else{
          let {VILL_CODE,HOD_CODE,SECTOR_CODE,PARCEL_ID}=dataWithRangeHandled;
          return `${VILL_CODE}${HOD_CODE}${SECTOR_CODE}${PARCEL_ID}`
        }
      }
      const landsInfoDetails = await api.post("/lands/info", {dlsKey:HandelCreateDlsKey(dataWithRangeHandled)});
      
      setLandshaveRegulation(landsInfoDetails?.data?.data?.landUse?.length>0);      
      setLaws([ConvertObjectResultSaerch(landsInfoDetails?.data?.data)])
      handleZoomCustomShowResult({
        data:landsInfoDetails?.data?.data?.geometry,
        view: view,
        graphicsLayer: graphicsLayerSelectedParcels, 
      })

      await addNewLog({
        ipAddress: auth.ipAddress,
        hostname: auth.hostname,
        logDescription: `${generateTextFromJson(data,"بحث")}`});
    }catch(err){
      console.error(err)
    }finally{
      handleLoading(loadingDispatch, false);
      clearDrawings();
    }
  
  };

  const onEmployeeSubmit = async () => {
    const noError = await trigger();
    if (!noError) return;
    const data = getValues();
    data.SECTOR_CODE = data.SECT_CODE;
    delete data.SECT_CODE;
    const isEmpty = !Object.values(data).some((property) => property);
    if (isEmpty && !drawingGeometry) return;
    if (!isEmpty) fixParcelDataPadding(data);
    try {
      handleLoading(loadingDispatch, true);
      // shape area filtering is not working
      const fixedDotsData = Object.fromEntries(
        Object.entries(data).map((item) => [item[0].replace("%", "."), item[1]])
      );
      const cleanedData = cleanObject(fixedDotsData);
      const dataWithRangeHandled = handleRangedItems(cleanedData);
      const query = createFilterQuery(
        dataWithRangeHandled,
        map.parcelsIntersectFields
      );
      const { res: parcelAttributes } = await getEsriData({
        token: auth.esriToken,
        layerId: esriUrls.Parcels_Intersect,
        layer: process.env.REACT_APP_PetraLayers_Table,
        neededDomains: ["ZONE_ID"],
        featureOrMap: "MapServer",
        query,
        geometry: drawingGeometry,
        view,
      });

      if (!parcelAttributes.length && drawingGeometry) {
        NotificationManager.warning("الرسم لا يتقاطع مع طبقة PARCEL INTERSECT");
      }

      handleZoom(parcelAttributes, view, graphicsLayer);
      if (parcelAttributes.length) {
        const { res: zoneFeaturesAttributes } = await getEsriData({
          token: auth.esriToken,
          layerId: esriUrls.ZONING_DESC,
          layer: process.env.REACT_APP_PetraLayers_Table,
          featureOrMap: "MapServer",
          view,
        });
        setZones(zoneFeaturesAttributes);
        setSearchedParcels(parcelAttributes);
      }
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }

    handleLoading(loadingDispatch, false);
    clearDrawings();
  };

  /**
   *
   * @param {arr} clearArr array of needed clear operations
   * ["allParcels" , "dls","villCodeChange,sectorCodeChange,parcelIdChange"]
   */
  const handleClearForm = (clearArr) => {
    if (clearArr.includes("allParcels")) {
      ["VILL_CODE", "SECT_CODE", "PARCEL_ID", "HOD_CODE"].forEach((field) =>
        setValue(field, "")
      );
    }
    if (clearArr.includes("villCodeChange")) {
      ["SECT_CODE", "PARCEL_ID", "HOD_CODE", "DLS_KEY"].forEach((field) =>
        setValue(field, "")
      );
    }
    if (clearArr.includes("HodCodeChange")) {
      ["SECT_CODE", "PARCEL_ID"].forEach((field) => setValue(field, ""));
    }
    if (clearArr.includes("sectorCodeChange")) {
      ["PARCEL_ID"].forEach((field) => setValue(field, ""));
    }
    if (clearArr.includes("parcelIdChange")) {
      ["HOD_CODE"].forEach((field) => setValue(field, ""));
    }
    if (clearArr.includes("dls")) {
      setValue("DLS_KEY", "");
    }
    if (clearArr.includes("zones")) {
      ["ZONE_ID", "Shape%STArea()_to", "Shape%STArea()_from"].forEach((field) =>
        setValue(field, "")
      );
    }
  };

  function clearZoom() {
    handleZoom([], view, graphicsLayer);
    handleZoom([], view, graphicsLayerSelectedParcels);
    graphicsLayer?.removeAll();
    graphicsLayerSelectedParcels.removeAll();
  }

  function clearLaws() {
    setLaws(null);
    clearZoom();
  }

  function clearSearchedParcels() {
    setSearchedParcels(null);
    clearZoom();
  }

  const zoneEditParcelZoom = (data) => {
    handleZoom([data], view, graphicsLayerSelectedParcels, {
      color: [11, 250, 47, 1],
      width: 2,
    });
  };

  const deleteParcelFromRequest = (data) => {
    handleLoading(loadingDispatch, true);
    setSearchedParcels((prevState) => {
      const tempPrevState = [...prevState];
      const newState = tempPrevState.filter(
        (item) => item.OBJECTID !== data.OBJECTID
      );
      graphicsLayerSelectedParcels.removeAll();
      handleZoom(newState, view, graphicsLayer);
      if (!newState.length) return null;
      return newState;
    });
    handleLoading(loadingDispatch, false);
  };

  async function parcelZoneEditSubmit(data) {

    const tempData = {
      ...data,
      type: editRegulationsRequestsType["تعديل استعمال قطع"],
      status: editRegulationsRequestsStatus["تحت المعالجة"],
      USERNAME: auth.userDetails.details.userName,
    };
    delete tempData.OBJECTID;
    try {
      handleLoading(loadingDispatch, true);
      // get attachments that coming form the input
      const attachmentWithFileObj = files
        .filter((attachment) => attachment.inputFile)
        .map((attachment) => attachment.inputFile);
      const filesFromInput = handleGetDataFromInput(attachmentWithFileObj);
      // create new request
      const urlRequestParcelsRel = `${process.env.REACT_APP_SERVICE_ENDPOINT}/${process.env.REACT_APP_UserTables_Table}/FeatureServer/${esriUrls.EditRegulationsRequests}`;
      const requestParcelsRelAddRes = await performActionOnFeature({
        url: urlRequestParcelsRel,
        objs: [tempData],
        files: filesFromInput,
        action: "add",
      });
      const createdRequestObjectId =
        requestParcelsRelAddRes.addFeatureResults[0].objectId;
      // create parcel edit request details
      const urlParcelRequests = `${process.env.REACT_APP_SERVICE_ENDPOINT}/${process.env.REACT_APP_UserTables_Table}/FeatureServer/${esriUrls.RequestParcelsRel}`;
      const searchedParcelsToSave = searchedParcels.map((parcel) => ({
        ParcelObjectID: parcel.OBJECTID,
        ZONE_ID: selectedModalZoneValue.ZONE_ID,
        REQUESTID: createdRequestObjectId,
      }));

      /* const resParcelRequests = */ await performActionOnFeature({
        url: urlParcelRequests,
        objs: searchedParcelsToSave,
        action: "add",
        notificationMessages: {
          onSuccessMessage: "تم انشاء الطلب بنجاح",
          onErrorMessage: "حدث خطأ ما",
        },
      });

      await addNewLog({
        ipAddress: auth.ipAddress,
        hostname: auth.hostname,
        logDescription: "ارسال طلب تغيير صفة استعمال",
      });
      navigate("/requests");
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    handleLoading(loadingDispatch, false);
  }
  
  const [selectedParcelZone, setSelectedParcelZone] = useState(null);
  const selectedParcelZoneFormMethods = useForm();
  const [ParcelEditZoneModalDialogState, ParcelEditZoneModalDispatchDialog] =
    useReducer(dialogReducer, dialogInitState);
  const toggleValidateOwnershipDialog = (data) => {
    if (data) {
      const selectedZone = zones.find((item) => item.ZONE_ID === data.ZONE_ID);
      setSelectedParcelZone(selectedZone);
    }
    ParcelEditZoneModalDispatchDialog({ type: "TOGGLE" });
  };

  // search parcel zone modal
  const [parcelsToZoom, setParcelsToZoom] = useState([]);
  const [zoneModalDialogState, zoneModalDispatchDialog] = useReducer(
    dialogReducer,
    dialogInitState
  );
  const toggleZoneModalDialog = (data, parcelsToZoomParam) => {    
    if (data) {
      const selectedZone = allZones.find(
        (item) => item.ZONE_ID === data.ZONE_ID
      );
      setParcelsToZoom(parcelsToZoomParam);
      setSelectedParcelZone(selectedZone);
    }
    zoneModalDispatchDialog({ type: "TOGGLE" });
  };

  // DeletePdfConfirm
    const [parcelToDeletePdf, setParcelToDeletePdf] = useState(null);
    const [DeletePdfModalDialogState, DeletePdfModalDispatchDialog] =
      useReducer(dialogReducer, dialogInitState);

    const toggleDeletePdfModalDialog = async(data) => {  
      if (data) {
        setParcelToDeletePdf(data[0]);
      }
      DeletePdfModalDispatchDialog({ type: "TOGGLE" });
    };
    
    const handleDeletePdf = async () => {
      handleLoading(loadingDispatch, true);
      try {
        await api.post("/pdf/print/lock", {
          dlsKey:parcelToDeletePdf.DLS_KEY,
          lockStatus:LockTypeEnum.allow,
          deleteDocs:true
        });  
        await addNewLog({
          ipAddress: auth.ipAddress,
          hostname: auth.hostname,
          logDescription: `${generateTextFromJson({},`${parcelToDeletePdf?.DLS_KEY} تعطيل المخططات المتعلقة بالارض`)} `});
        
        NotificationManager.success("تم حذف المخططات المتعلقة بهذه القطعة");
        // eslint-disable-next-line no-empty
      } catch(err) {
        ErrorHandelFunctionApp(err) 
      }
      handleLoading(loadingDispatch, false);
  
      DeletePdfModalDispatchDialog({ type: "TOGGLE" });
    };
  

  const updateIsPrintableUI = (dlsKey, isPrintable) => {
    
    setLaws((prevLaws) => {
      const tempLaws = prevLaws.map((law) => {
        if (law.parcels) {
          const tempParcels = law.parcels.map((parcel) => {
            if (dlsKey !== parcel.DLS_KEY) return parcel;

            return { ...parcel, isPrintable };
          });
          return { ...law, parcels: tempParcels };
        }
        if (dlsKey !== law.DLS_KEY) return law;

        return { ...law, isPrintable };
      });
      return tempLaws;
    });
  };
  
  const lockPrintParcel = async (parcel) => {   
    handleLoading(loadingDispatch, true);
    try {
      let isPrintable = 1;
      if (parcel.isPrintable > 0) {
        isPrintable = 0;
      } else {
        isPrintable = 1;
      }

      await updateIsPrintableUI(parcel.DLS_KEY, isPrintable);

      try{
        await api.post("/lands/print/prevent", {
          dlsKey:parcel.DLS_KEY,
          lockType:isPrintable===0?LockTypeEnum.prevent:LockTypeEnum.allow
        });
      }catch(err){
        throw Error();
      }
      await addNewLog({
        ipAddress: auth.ipAddress,
        hostname: auth.hostname,
        logDescription: isPrintable
          ? `فك تجميد الطباعة على قطعة ${parcel.DLS_KEY}`
          : `تجميد الطباعة على قطعة ${parcel.DLS_KEY}`,
      });
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    handleLoading(loadingDispatch, false);
  };

  const [printDialogState, printDispatchDialog] = useReducer(
    dialogReducer,
    dialogInitState
  );
  const [printData, setPrintData] = useState(null);
  const [ZoneCodeArray,setZoneCodeArray]=useState([]);

  useEffect(()=>{
    setZoneCodeArray(laws?.map((data)=>(data?.ZONE_ID)))
  },[laws])

  const togglePrintDialog = async(data) => {    
    printDispatchDialog({ type: "TOGGLE" });
    if (data) setPrintData(data[0]);
  };

  // print if statements
  // roles.employeeWithPrintDraft &&
  // roles.employeeWithPrintOfficial &&
  // defaultActiveKey={roles.manager ? "officialWork" : "citizen"}
  let tabDefaultActiveKey = "";
  if (permissions.employeeWithPrintDraft) tabDefaultActiveKey = "officialWork";
  else if (permissions.employeeWithPrintOfficial)
    tabDefaultActiveKey = "citizen";
  else if (roles.manager) tabDefaultActiveKey = "citizen";
  

  if (!searchedParcels && !laws)
    return (
      <form className="parcels-search">
        <Accordion defaultActiveKey="0" className="custom-accordion">
          <div>
            <CustomToggle
              selectedAccordion={selectedAccordion}
              setSelectedAccordion={setSelectedAccordion}
              eventKey="0"
            >
              <h2 className="content__title title my-3">بحث الأراضي</h2>
              <Caret />
            </CustomToggle>
            <Accordion.Collapse eventKey="0">
              <>
                <Form.Group
                  className="mb-3 input input-md"
                  controlId="parcels-search_VILL_CODE"
                >
                  <Form.Label>القرية</Form.Label>
                  <Form.Select
                    {...register("VILL_CODE", {
                      onChange: () =>
                        handleClearForm(["villCodeChange", "dls", "zones"]),
                    })}
                  >
                    <option value="">الرجاء الاختيار</option>
                    {villages &&
                      villages.map((village) => (
                        <option
                          key={village.VILL_ANAME}
                          value={village.VILL_CODE}
                        >
                          {village.VILL_ANAME} - {village.VILL_CODE}
                        </option>
                      ))}
                  </Form.Select>
                  {errors.VILL_CODE && (
                    <Form.Text className="text-danger">
                      {errors.VILL_CODE.message}
                    </Form.Text>
                  )}
                </Form.Group>
                <Form.Group
                  className="mb-3 input input-md"
                  controlId="parcels-search_HOD_CODE"
                >
                  <Form.Label>الحوض</Form.Label>
                  <Controller
                    control={control}
                    defaultValue=""
                    name="HOD_CODE"
                    render={({ field: { onChange, name, ref, value } }) => (
                      <Select
                        inputRef={ref}
                        name={name}
                        value={
                          hods
                            ?.filter(
                              (hod) => hod.VILL_CODE === Number(watch.VILL_CODE)
                            )
                            ?.find((item) => item.HOD_CODE === value) || ""
                        }
                        classNamePrefix="react-select"
                        options={
                          watch.VILL_CODE
                            ? hods
                                .filter(
                                  (hod) =>
                                    hod.VILL_CODE === Number(watch.VILL_CODE)
                                )
                                .sort((a, b) => a.HOD_CODE - b.HOD_CODE)
                            : []
                        }
                        getOptionLabel={(option) =>
                          `${option.HOD_ANAME} - ${option.HOD_CODE}`
                        }
                        getOptionValue={(option) => option.HOD_CODE}
                        onChange={(val) => {
                          onChange(val.HOD_CODE);
                          handleClearForm(["HodCodeChange", "dls", "zones"]);
                        }}
                      />
                    )}
                    rules={{
                      required: {
                        value: watch.VILL_CODE,
                        message: "الرجاء إدخال الحقل",
                      },
                    }}
                  />
                  {watch.VILL_CODE && errors.HOD_CODE && (
                    <Form.Text className="text-danger">
                      {errors.HOD_CODE.message}
                    </Form.Text>
                  )}
                </Form.Group>
                <Form.Group
                  className="mb-3 input input-md"
                  controlId="ParcelsSearch-3"
                >
                  <Form.Label>الحي</Form.Label>
                  <Controller
                    control={control}
                    defaultValue=""
                    name="SECT_CODE"
                    render={({ field: { onChange, name, ref, value } }) => (
                      <Select
                        inputRef={ref}
                        name={name}
                        value={
                          sectors
                            ?.filter(
                              (sector) =>
                                sector.HOD_CODE === Number(watch.HOD_CODE) &&
                                sector.VILL_CODE === Number(watch.VILL_CODE)
                            )
                            ?.find((item) => item.SECT_CODE === value) || ""
                        }
                        classNamePrefix="react-select"
                        options={
                          watch.HOD_CODE
                            ? sectors?.filter(
                                (sector) =>
                                  sector.HOD_CODE === Number(watch.HOD_CODE) &&
                                  sector.VILL_CODE === Number(watch.VILL_CODE)
                              )
                            : []
                        }
                        getOptionLabel={(option) =>
                          `${option.SECT_CODE} - ${option.SECT_ANAME}`
                        }
                        getOptionValue={(option) => option.SECT_CODE}
                        onChange={(val) => {
                          onChange(val.SECT_CODE);
                          handleChangeSector(val.SECT_CODE);
                          handleClearForm(["sectorCodeChange", "dls", "zones"]);
                        }}
                      />
                    )}
                    rules={{
                      required: {
                        value: watch.VILL_CODE,
                        message: "الرجاء إدخال الحقل",
                      },
                    }}
                  />
                  {watch.VILL_CODE && errors.SECT_CODE && (
                    <Form.Text className="text-danger">
                      {errors.SECT_CODE.message}
                    </Form.Text>
                  )}
                </Form.Group>
                <Form.Group
                  className="mb-3 input input-md"
                  controlId="parcels-search_PARCEL_ID"
                >
                  <Form.Label>رقم القطعة</Form.Label>
                  <Controller
                    control={control}
                    defaultValue=""
                    name="PARCEL_ID"
                    render={({ field: { onChange, name, ref, value } }) => (
                      <Select
                        inputRef={ref}
                        name={name}
                        value={
                          parcels?.find((item) => item.PARCEL_ID === value) ||
                          ""
                        }
                        classNamePrefix="react-select"
                        options={watch.SECT_CODE !== undefined ? parcels : []}
                        getOptionLabel={(option) => option.PARCEL_ID}
                        getOptionValue={(option) => option.PARCEL_ID}
                        onChange={(val) => {
                          onChange(val.PARCEL_ID);
                          handleClearForm(["dls", "zones"]);
                        }}
                      />
                    )}
                    rules={{
                      required: {
                        value: watch.VILL_CODE,
                        message: "الرجاء إدخال الحقل",
                      },
                    }}
                  />
                  {watch.VILL_CODE && errors.PARCEL_ID && !badServerError && (
                    <Form.Text className="text-danger">
                      {errors.PARCEL_ID.message}
                    </Form.Text>
                  )}
                  {badServerError && (
                    <Form.Text className="text-danger">
                      {badServerError}
                    </Form.Text>
                  )}
                </Form.Group>
              </>
            </Accordion.Collapse>
          </div>
          <div>
            <CustomToggle
              selectedAccordion={selectedAccordion}
              setSelectedAccordion={setSelectedAccordion}
              eventKey="1"
            >
              <h2 className="parcels-search__title  my-3">
                البحث عن طريق ادخال مفتاح القطعة
              </h2>
              <Caret />
            </CustomToggle>
            <Accordion.Collapse eventKey="1">
              <Form.Group className="mb-3 input input-md" controlId="DLS_KEY">
                <Form.Label>DLS KEY</Form.Label>
                <Form.Control
                  autoComplete="off"
                  type="number"
                  {...register("DLS_KEY", {
                    onChange: () => handleClearForm(["allParcels", "zones"]),
                  })}
                />
              </Form.Group>
            </Accordion.Collapse>
          </div>
          {roles.employee && (
            <>
              {" "}
              <div>
                {/* <CustomToggle
                  selectedAccordion={selectedAccordion}
                  setSelectedAccordion={setSelectedAccordion}
                  eventKey="3"
                >
                  <h2 className="parcels-search__title  my-3">
                    البحث عن طريق الرسم على الخريطة
                  </h2>
                  <Caret />
                </CustomToggle> */}
                <Accordion.Collapse eventKey="3">
                  <div className="parcels-search__actions">
                    <button
                      type="button"
                      className="btn btn--primary custom_tooltip"
                      onClick={createSketch.bind(this, {
                        graphicLayer: sketchGraphicsLayer,
                        sketchVM,
                        tool: "polyline",
                        setItem: setDrawingGeometry,
                        onCreateExtraAction: () => {
                          handleClearForm(["allParcels", "dls", "zones"]);
                        },
                      })}
                    >
                      <i className="fa-solid fa-arrow-trend-up" />
                      <span className="tooltiptext">خط</span>
                    </button>
                    <button
                      type="button"
                      className="btn btn--primary custom_tooltip"
                      onClick={createSketch.bind(this, {
                        graphicLayer: sketchGraphicsLayer,
                        sketchVM,
                        tool: "polygon",
                        setItem: setDrawingGeometry,
                        onCreateExtraAction: () => {
                          handleClearForm(["allParcels", "dls", "zones"]);
                        },
                      })}
                    >
                      <i className="fa-solid fa-draw-polygon" />{" "}
                      <span className="tooltiptext">مضلع</span>
                    </button>
                    <button
                      type="button"
                      className="btn btn--primary custom_tooltip"
                      onClick={createSketch.bind(this, {
                        graphicLayer: sketchGraphicsLayer,
                        sketchVM,
                        tool: "multipoint",
                        setItem: setDrawingGeometry,
                        onCreateExtraAction: () => {
                          handleClearForm(["allParcels", "dls", "zones"]);
                        },
                      })}
                    >
                      <i className="fa-solid fa-hand-pointer" />{" "}
                      <span className="tooltiptext">نقاط</span>
                    </button>
                    <button
                      type="button"
                      className="btn btn--primary custom_tooltip"
                      onClick={createSketch.bind(this, {
                        graphicLayer: sketchGraphicsLayer,
                        sketchVM,
                        tool: "circle",
                        setItem: setDrawingGeometry,
                        onCreateExtraAction: () => {
                          handleClearForm(["allParcels", "dls", "zones"]);
                        },
                      })}
                    >
                      <i className="fa-regular fa-circle" />{" "}
                      <span className="tooltiptext">دائرة</span>
                    </button>
                    <button
                      type="button"
                      className="btn btn--primary custom_tooltip"
                      onClick={clearDrawings}
                    >
                      <i className="fa-solid fa-xmark" />
                      <span className="tooltiptext">حذف</span>
                    </button>
                  </div>
                </Accordion.Collapse>
              </div>
              <div>
                {/* <CustomToggle
                  selectedAccordion={selectedAccordion}
                  setSelectedAccordion={setSelectedAccordion}
                  eventKey="2"
                >
                  <h2 className="parcels-search__title  my-3">
                    البحث عن طريق التحديد الوصفي
                  </h2>
                  <Caret />
                </CustomToggle> */}
                <Accordion.Collapse eventKey="2">
                  <>
                    <Controller
                      control={control}
                      defaultValue=""
                      name="ZONE_ID"
                      render={({ field: { onChange, name, ref, value } }) => (
                        <Select
                          inputRef={ref}
                          name={name}
                          value={
                            zonesLookup?.find((item) => item.value === value) ||
                            ""
                          }
                          classNamePrefix="react-select"
                          options={zonesLookup}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.code}
                          onChange={(val) => {
                            handleClearForm(["allParcels", "dls"]);
                            onChange(val.value);
                          }}
                        />
                      )}
                    />
                    <div className="form-grid grid grid-of-2">
                      <Form.Group
                        className="mb-3 input input-md"
                        controlId="ParcelsSearch-11"
                      >
                        <Form.Label>المساحة</Form.Label>
                        <Form.Control
                          autoComplete="off"
                          type="number"
                          placeholder="من"
                          {...register(`Shape%STArea()_from`, {
                            onChange: () => {
                              handleClearForm(["allParcels", "dls"]);
                            },
                          })}
                        />
                      </Form.Group>
                      <Form.Group
                        className="mb-3 input input-md"
                        controlId="ParcelsSearch-12"
                        style={{ alignSelf: "end" }}
                      >
                        <Form.Control
                          autoComplete="off"
                          type="number"
                          placeholder="إلى"
                          {...register(`Shape%STArea()_to`, {
                            onChange: () => {
                              handleClearForm(["allParcels", "dls"]);
                            },
                          })}
                        />
                      </Form.Group>
                    </div>
                  </>
                </Accordion.Collapse>
              </div>
            </>
          )}
        </Accordion>

        <div style={{ display: "flex", gap: "16px" }}>
          <button
            disabled={
              watch[`Shape%STArea()_from`] ||
              watch[`Shape%STArea()_to`] ||
              watch.ZONE_ID ||
              drawingGeometry
            }
            type="button"
            onClick={onSubmit}
            className="btn btn--primary"
          >
            إبحث
          </button>
          {permissions.employeeWithChangeRequests && (
            <button
              type="button"
              className="btn btn--primary"
              onClick={onEmployeeSubmit}
            >
              تعديل صفة استعمال اراضي
            </button>
          )}
        </div>
      </form>
    );
  if (laws)
    return (
      <>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h2 className="content__title title mt-3">نتائج البحث</h2>
          <button type="button" onClick={clearLaws}>
            <ArrowLeft />
          </button>
        </div> 
        <div style={{ display:"flex",justifyContent:"space-between",marginBottom:"1.5rem" }}>
          <div>
            {permissions.employeeCanDisablePeoplePrint&&
            <button
              type="button"
              className={`btn ${(laws[0]?.parcels?.length>0? laws[0]?.parcels[0]?.isPrintable:laws[0]?.isPrintable )? "btn--green" : "btn--red"}  me-2`}
              onClick={()=>{lockPrintParcel(laws[0]?.parcels?.length>0?laws[0]?.parcels[0]:laws[0])}}>
                  {(laws[0]?.parcels?.length>0? laws[0]?.parcels[0]?.isPrintable:laws[0]?.isPrintable) ? 
                  <span><span><Lock/></span> <span style={{margin:".5rem"}}>قفل العنصر</span></span>:
                  <span><span><Unlock/></span> <span style={{margin:".5rem"}}>الغاء قفل العنصر</span></span>}
            </button>}  
          </div>
          <div>
          {(permissions.employeeCanDisablePdf || roles.manager) && (
              <button
                style={{marginLeft:".5rem"}}
                type="button"
                className="btn btn--primary"
                onClick={toggleDeletePdfModalDialog.bind(this, filterUniqueDLSKeysFirst(laws))}
              >
                <Trash/>
              </button>
            )}  
            <button
                type="button"
                className="btn btn--primary ms-2"
                onClick={async () => {
                  try {
                    const { color, width } = { color: [242, 250, 47, 1], width: 2 };
                    const polygonMarker = {
                      type: "simple-fill",
                      outline: { width, color },
                    };

                    const centroidData = filterUniqueDLSKeysFirst(laws)
                      .map((item) => {
                        if (item.geometry && item.geometry.type) {
                          return new Graphic({
                            attributes: { ...item },
                            geometry: {
                              ...item.geometry,
                              type: item.geometry.type, 
                            },
                            symbol: polygonMarker,
                          });
                        }
                        return null;
                      })
                      ?.filter((graphic) => graphic !== null);

                    if (graphicsLayerSelectedParcels && view) {
                      graphicsLayerSelectedParcels.removeAll();
                      graphicsLayerSelectedParcels.addMany(centroidData);

                      if (centroidData.length > 0) {
                        await view.goTo(centroidData);
                      }
                    }

                    await addNewLog({
                      ipAddress: auth.ipAddress,
                      hostname: auth.hostname,
                      logDescription: `${generateTextFromJson(filterUniqueDLSKeysFirst(laws), "تكبير على")}`,
                    });
                  } catch (error) {
                    console.error(error);
                    ErrorHandelFunctionApp(error);
                  }
                }}
              >
                <ZoomIn />
              </button>


            {( permissions.employeeWithPrintOfficial ||
              permissions.employeeWithPrintDraft ||
              roles.manager) && (
              <button
                type="button"
                className="btn btn--primary"
                onClick={togglePrintDialog.bind(this, {...filterUniqueDLSKeysFirst(laws),zoneCodeArray:ZoneCodeArray})}
              >
                <Printer />
              </button>
            )}
          </div>
        </div>
   
        <div className="employee-requests">
            {laws?.map((parcel) => (
                <>
                {landshaveRegulation&&
                    <button
                      style={{width:"100%"}}
                      type="button"
                      className="btn btn--primary"
                      onClick={toggleZoneModalDialog.bind(this, parcel, parcel)}>
                          عرض الأحكام
                    </button>}
                  <ParcelCard
                    parcel={parcel}
                />
              </>
            ))}
        </div>
        <Dialog
          state={zoneModalDialogState}
          dispatch={zoneModalDispatchDialog}
          footer={false}
          title="الأحكام"
          closeButton
          centered
        >
          {selectedParcelZone && (
            <ParcelLaws
              law={selectedParcelZone}
              methods={selectedParcelZoneFormMethods}
              disabled
              dataToZoom={parcelsToZoom}
              view={view}
              graphicsLayer={graphicsLayerSelectedParcels}
              extraZoomFunc={toggleZoneModalDialog}
            />
          )}
        </Dialog>
        <Dialog
          state={printDialogState}
          dispatch={printDispatchDialog}
          footer={false}
          title="طباعة مخطط"
          closeButton
          centered
        >
          <Tabs
            onSelect={(key) => {
              setSelectItem(key)
            }}
          
            defaultActiveKey={tabDefaultActiveKey}
            id="fill-tab-example"
            className={`mb-3 p-0 ${
              (!permissions.employeeWithPrintDraft ||
                !permissions.employeeWithPrintOfficial) &&
              roles.employee &&
              "d-none"
            }`}
            fill
          >
              <Tab eventKey="craete" title="أصدار مخطط">
              {SelectItem==="craete"&&
                <PrintParcels
                  printData={{...printData,typePrintValue:"أصدار مخطط"}}
                  toggleDialog={togglePrintDialog}
                  WithCreatePayment
                />}
              </Tab>
            {(permissions.employeeWithPrintOfficial || roles.manager) && (
              <Tab eventKey="citizen" title="طباعة لمواطن">
                {SelectItem==="citizen"&&
                <PrintParcels
                  printData={{...printData,typePrintValue:"طباعة لمواطن"}}
                  toggleDialog={togglePrintDialog}
                  withCheck
                  withEmployee
                />}
              </Tab>
            )}
            {(permissions.employeeWithPrintDraft || roles.manager) && (
              <Tab eventKey="officialWork" title="طباعة للعمل الرسمي">
                {SelectItem==="officialWork"&&
                <PrintParcels
                  printData={{...printData,typePrintValue:"طباعة للعمل الرسمي"}}
                  toggleDialog={togglePrintDialog}
                  isOfficial
                />}
              </Tab>
            )}
            {(permissions.employeeWithPrintOfficial || roles.manager) && (
              <Tab
                eventKey="governmentofficialWork"
                title="كتاب رسمي من الجهة الحكومية "
              >
                {SelectItem==="governmentofficialWork"&& <PrintParcels
                  printData={{...printData,typePrintValue:"كتاب رسمي من الجهة الحكومية"}}
                  toggleDialog={togglePrintDialog}
                  isGovernmentWork
                />}
               
              </Tab>
            )}
            {(permissions.employeeWithPrintOfficial || roles.manager) && (
              <Tab
                eventKey="privateofficialWork"
                title="الجهات الرسمية الغير معفية"
              >
                {SelectItem==="privateofficialWork"&&
                <PrintParcels
                  printData={{...printData,typePrintValue:"الجهات الرسمية الغير معفية"}}
                  toggleDialog={togglePrintDialog}
                  isPrivateOfficialWork
                />}
              </Tab>
            )}
            

          </Tabs>
        </Dialog>
        <Dialog
          state={DeletePdfModalDialogState}
          dispatch={toggleDeletePdfModalDialog}
          footer
          confirmFunction={handleDeletePdf}
          title="حذف المخططات المتعلقة بلارض"
          closeButton
          centered
        />
        
      </>
    );
  if (searchedParcels)
    return (
      <>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h2 className="content__title title mt-3">
            شاشة تعديل صفة إستعمال الأراضي
          </h2>
          <button
            type="button"
            onClick={clearSearchedParcels}
            className="mt-3"
            style={{ alignSelf: "baseline" }}
          >
            <ArrowLeft />
          </button>
        </div>
        <form
          onSubmit={editParcelZoneHandleSubmit(parcelZoneEditSubmit)}
          id="editParcelZone"
        >
          <Form.Group className="mb-3 input input-md" controlId="DESCRIPTION">
            <Form.Label className="required">وصف الطلب</Form.Label>
            <Form.Control
              {...editParcelZoneRegister("DESCRIPTION", {
                required: "الرجاء ادخال الحقل",
              })}
              as="textarea"
            />
            {editParcelZoneError.DESCRIPTION && (
              <Form.Text className="text-danger">
                {editParcelZoneError.DESCRIPTION.message}
              </Form.Text>
            )}
          </Form.Group>
        </form>
        <button
          className="btn btn-primary"
          type="button"
          onClick={toggleFilesDialog}
        >
          مرفقات الطلب ({files.length})
        </button>
        <div className="parcel_change_request__container">
          {searchedParcels.map((searchedParcel) => (
            <EditParcelZoneCard
              key={`${searchedParcel.DLS_KEY}-${searchedParcel.OBJECTID}`}
              searchedParcel={searchedParcel}
              deleteParcelFromRequest={deleteParcelFromRequest}
              zoneEditParcelZoom={zoneEditParcelZoom}
              toggleDialog={toggleValidateOwnershipDialog}
            />
          ))}
        </div>
        <div className="sticky-button">
          <button
            type="submit"
            form="editParcelZone"
            className=" btn btn--primary w-100"
          >
            تغيير صفة الإستعمال للأراضي المختارة
          </button>
        </div>
        <Modal
          show
          // dialogClassName={dialogClassName}
          backdrop={false}
          className="zones-modal"
          enforceFocus={false}
        >
          <Modal.Body>
            <h5 className="text-center text-bold">شاشة الأحكام</h5>

            <Select
              classNamePrefix="react-select"
              className="zones-select"
              options={zonesLookup}
              value={selectedModalZone}
              onChange={(value) => setSelectedModalZone(value)}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.code}
            />
            <form>
              <ParcelLaws
                methods={editParcelZoneMethods}
                law={selectedModalZoneValue}
                disabled
              />
            </form>
          </Modal.Body>
        </Modal>
        <Dialog
          state={ParcelEditZoneModalDialogState}
          dispatch={ParcelEditZoneModalDispatchDialog}
          footer={false}
          title="التحقق من ملكية قطعة ارض"
          closeButton
          centered
        >
        {selectedParcelZone && (
            <ParcelLaws
              law={selectedParcelZone}
              methods={selectedParcelZoneFormMethods}
              disabled
            />
          )}
        </Dialog>
        <Dialog
          state={filesDialogState}
          dispatch={filesDispatchDialog}
          footer={false}
          title="مرفقات الطلب"
          closeButton
          centered>
          <FilesModal files={files} setFiles={setFiles} deletable />
        </Dialog>
      </>
    );
}

export default ParcelsSearch;

function filterUniqueDLSKeysFirst(data) {

  if (!Array.isArray(data)) {
      return []; 
  }
  const seenKeys = [];
  const filteredData = []; 
  data.forEach(item => {
      if (!seenKeys?.includes(item?.DLS_KEY)) {
          seenKeys.push(item?.DLS_KEY); 
          filteredData.push(item); 
      }
  });

  return filteredData;
}
